"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableContainer = TableContainer;
var jsx_runtime_1 = require("react/jsx-runtime");
var loader_1 = require("../loader");
function TableContainer(props) {
    var _a = props.isFetching, isFetching = _a === void 0 ? false : _a, children = props.children;
    return ((0, jsx_runtime_1.jsxs)("div", { className: "relative rounded-md", children: [children, isFetching && (0, jsx_runtime_1.jsx)(loader_1.Loader, { variant: "overlay", size: "sm" })] }));
}
